import styled, { css } from 'styled-components';

import { mediaQuery, Text, H3 } from '@catalyze/ui';

export const NetWorth = styled(Text)`
    font-size: ${({ theme }) => theme.fontSizes[3]};
    margin-right: 1em;
    ${mediaQuery(
        2,
        css`
            font-size: ${({ theme }) => theme.fontSizes[5]};
            font-weight: 700;
        `
    )}
`;

export const Worth = styled.span`
    color: ${({ theme }) => theme.colors.logoPrimary};
    margin-right: 0.5em;
    font-weight: 700;
    ${mediaQuery(
        2,
        css`
            font-weight: normal;
        `
    )}
`;

export const Title = styled(H3)`
    margin: 0 1em 0 0.5rem;
    font-weight: 700;
    ${mediaQuery(
        2,
        css`
            margin: 0 1em 0 0.75em;
            font-weight: normal;
        `
    )}
`;
